import axios, { AxiosRequestConfig } from 'axios';

const CLIENT_API_KEY = process.env.NEXT_PUBLIC_CLIENT_API_KEY;
const BASE_URL = 'https://owworarpe5.execute-api.us-west-1.amazonaws.com/Prod/avalon';

export interface ApiResponse {
  body: any;
  statusCode: number;
}

type AuthHandlers = {
  logout: () => void;
  checkInstacartLink: () => void;
}

class ApiClient {
  private static instance: ApiClient;
  private authHandlers?: AuthHandlers;
  
  private constructor() {}

  public static getInstance(): ApiClient {
    if (!ApiClient.instance) {
      ApiClient.instance = new ApiClient();
    }
    return ApiClient.instance;
  }

  public setAuthHandlers(handlers: AuthHandlers) {
    this.authHandlers = handlers;
  }

  private handleInvalidSession() {
    // console.log('Invalid session detected, logging out...');
    if (this.authHandlers?.logout) {
      this.authHandlers.logout();
    }
  }

  private handleInvalidInstacartCredentials() {
    // console.log('Invalid Instacart credentials detected, updating state...');
    if (this.authHandlers?.checkInstacartLink) {
      this.authHandlers.checkInstacartLink();
    }
  }

  async request(config: AxiosRequestConfig): Promise<ApiResponse> {
    try {
      const response = await axios({
        ...config,
        url: `${BASE_URL}${config.url}`,
        headers: {
          apikey: CLIENT_API_KEY,
          'Content-Type': 'application/json',
          ...config.headers,
        },
      });

      // Handle successful responses
      if (response.status === 400 && response.data === 'Invalid session') {
        this.handleInvalidSession();
      }
      else if (response.status === 400 && response.data === 'Invalid Instacart credentials') {
        this.handleInvalidInstacartCredentials();
      }
      return {
        statusCode: response.status,
        body: response.data
      };
    } catch (error: any) {
      const errorResponse = {
        statusCode: error.response?.status || 500,
        body: error.response?.data || 'Unknown error occurred'
      };
      
      // Handle 400 errors
      if (error.response?.status === 400) {
        // console.log('Invalid request');
        if (error.response?.data === 'Invalid session') {
          // console.log('Invalid session detected, logging out...');
          this.handleInvalidSession();
        }
        else if (error.response?.data === 'Invalid Instacart credentials') {
          this.handleInvalidInstacartCredentials();
        }
        else if (error.response?.data === 'Not allowed to go online') {
          // console.log('Not allowed to go online');
        }
        else {
          // console.log('Invalid request');
        }
      }
      
      return errorResponse;
    }
  }
}

export const apiClient = ApiClient.getInstance(); 